import { RouteConfig } from 'vue-router';
import SuitabilityProfile from '@/modules/onboarding/suitability-profile/views/SuitabilityProfile/SuitabilityProfile.vue';
import SignUp from '@/modules/onboarding/signup/views/SignUp/SignUp.vue';
import { redirectToOnboardingSignUp } from '@/modules/common/routes/navigation-guards/redirectToOnboardingSignUp';

export const onboardingRoutes: RouteConfig[] = [
  {
    name: 'signup',
    path: '/signup',
    beforeEnter: redirectToOnboardingSignUp,
    component: SignUp,
    meta: {
      context: 'onboarding',
      requiresAuth: false
    }
  },
  {
    name: 'myprofile',
    path: '/suitability/my-profile',
    component: SuitabilityProfile,
    meta: {
      context: 'onboarding',
      requiresAuth: false
    }
  }
];
